import DS from "@/store"

const WHITELIST = [
  DS.adapters.http.defaults.basePath.replace(/https?:\/\//, ""),
  "studysync.com",
  "mackinvia.com",
  "mheducation.desire2learn.com",
  "95b2.http.cdn.softlayer.net",
  "95b2.https.cdn.softlayer.net"
]

let openInWindow = function (href) {
  let target = window.cordova ? "_system" : "_blank"
  window.open(href, target)
}

export default {
  name: "externalLinkWarning",

  // When the bound element is inserted into the DOM...
  inserted(el) {
    $(el).on("click", "a", e => {
      let hostName = e.currentTarget.hostname;
      let href = e.currentTarget.href;

      // only go further if they clicked a different host than the current host
      if (hostName && (hostName != window.location.hostname)) {
        // Prevent the link from taking over so we can force a new window
        e.preventDefault();

        // If we have the url whitelisted, let's open it in a new window
        if (_.some(WHITELIST, domain => _.includes(hostName, domain))) {
          openInWindow(href);
        } else {
          // If we're not whitelisted, let's confirm with the user before opening the window, allowing them to cancel the action
          if (confirm("You are about to leave SyncBlasts and visit another website. Do you want to continue?")) {
            openInWindow(href);
          }
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/directives/external-link-warning.js